var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhotoAndText = function SvgPhotoAndText(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 22,
    viewBox: "0 0 14.8 9.8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.985.6H1.83C1.15.6.6 1.151.6 1.83v6.155c0 .68.55 1.23 1.23 1.23h6.154c.68 0 1.23-.55 1.23-1.23V1.83c0-.68-.55-1.23-1.23-1.23M11.677 4.908h2.462M11.677 1.831h2.462M11.677 7.985h2.462"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.49 5.407a.57.57 0 0 1 .425.182l.043.053 1.911 2.697v.087a.73.73 0 0 1-.73.73H1.984a.73.73 0 0 1-.73-.73v-.02L2.43 6.884l.005-.006.003-.006a.56.56 0 0 1 .914.012 1.116 1.116 0 0 0 1.862 0l.818-1.229a.56.56 0 0 1 .458-.249Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.677 4.908a1.23 1.23 0 1 0 0-2.462 1.23 1.23 0 0 0 0 2.462"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhotoAndText);
export default ForwardRef;